const SHARE_TOAST_DURATION = 5000;

let shareToastTimeout;

function getShareUrl(container) {
  const fromData = container.dataset.shareUrl?.trim();
  if (fromData) {
    return fromData;
  }

  return window.location.href.split("#")[0];
}

function showShareToast(container, trigger) {
  const toast = document.querySelector(".blog-article__share-toast");
  if (!toast) {
    return;
  }

  window.clearTimeout(shareToastTimeout);
  trigger.classList.add("is-copied");
  toast.classList.add("is-visible");
  toast.setAttribute("aria-hidden", "false");

  shareToastTimeout = window.setTimeout(() => {
    toast.classList.remove("is-visible");
    toast.setAttribute("aria-hidden", "true");
    trigger.classList.remove("is-copied");
  }, SHARE_TOAST_DURATION);
}

async function copyShareUrl(url, container, trigger) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(url);
    } else {
      const input = document.createElement("textarea");
      input.value = url;
      input.setAttribute("readonly", "");
      input.style.position = "fixed";
      input.style.opacity = "0";
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    }

    showShareToast(container, trigger);
  } catch {
    trigger.setAttribute("title", "Unable to copy link");
  }
}

function initBlogArticleShare() {
  const container = document.querySelector(".blog-article__share");
  if (!container) {
    return;
  }

  const shareUrl = getShareUrl(container);
  const encodedUrl = encodeURIComponent(shareUrl);

  const linkedin = container.querySelector(
    ".blog-article__share-link--linkedin",
  );
  const facebook = container.querySelector(
    ".blog-article__share-link--facebook",
  );
  const copy = container.querySelector(".blog-article__share-link--copy");

  if (linkedin) {
    linkedin.href = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
    linkedin.target = "_blank";
    linkedin.rel = "noopener noreferrer";
  }

  if (facebook) {
    facebook.href = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
    facebook.target = "_blank";
    facebook.rel = "noopener noreferrer";
  }

  if (copy) {
    copy.addEventListener("click", (event) => {
      event.preventDefault();
      copyShareUrl(shareUrl, container, copy);
    });
  }
}

document.addEventListener("DOMContentLoaded", initBlogArticleShare);

export { initBlogArticleShare };
